
     
<div class="question-container">
        <label [innerHTML]="label" [class.required]="isRequired && label" ></label>
 
  <mat-form-field appearance="outline" class="full-width">
       
    <input matInput
           [type]="type"
           [placeholder]="placeholder"
           [formControl]="control" />
    
    @if (prefix) {
      <span matTextPrefix>{{ prefix }}&nbsp;</span>
    }
    @if (suffix) {
      <span matTextSuffix>&nbsp;{{ suffix }}</span>
    }
    @if (showError && errorMessages.length) {    
      <mat-error>
        @for (msg of errorMessages; track msg) {
          {{ msg }}
        }
      </mat-error>
    }
  </mat-form-field>
</div>
